import { SelectMenuProps } from '../../../../components/UI/SelectMenu';
import { useLocale } from '../../../../hooks/useLocale';

export interface IPropertyType {
  id: number;
  name: string;
  ar_name: string;
}

class PropertyGenericTypeModel implements IPropertyType {
  id: number;
  name: string;
  ar_name: string;

  constructor(data: Partial<IPropertyType>) {
    this.id = data.id ?? 0;
    this.name = data.name ?? '';
    this.ar_name = data.ar_name ?? '';
  }

  /** From json to class instance */
  static fromJson(json: any): PropertyGenericTypeModel {
    return new PropertyGenericTypeModel({ ...json });
  }

  /** From class instance to json */
  toJson(): IPropertyType {
    return {
      id: this.id,
      name: this.name,
      ar_name: this.ar_name,
    };
  }

  get menuItem(): SelectMenuProps<this> {
    const { isArabic } = useLocale();
    return {
      id: this.id.toString(),
      label: isArabic ? this.ar_name : this.name,
      value: this,
    };
  }

  get menuItemByNull(): SelectMenuProps<this | null> {
    return this.id === 0 ? undefined : this.menuItem;
  }

  copyWith(data: Partial<IPropertyType>): PropertyGenericTypeModel {
    return new PropertyGenericTypeModel({
      ...this.toJson(),
      ...data,
    });
  }

  get displayName(): string {
    const { isArabic } = useLocale();
    return isArabic ? this.ar_name : this.name;
  }
}

export class PropertyTypeModel extends PropertyGenericTypeModel {}
export class PropertyServiceTypeModel extends PropertyGenericTypeModel {}
export class PropertyStatusModel extends PropertyGenericTypeModel {}
export class AnnouncementTypeModel extends PropertyGenericTypeModel {}

export class TransactionAmountTypeModel extends PropertyGenericTypeModel {}
